import React, { useRef, useState, useEffect, Suspense } from 'react';
import { animated, useSpring } from '@react-spring/web';
import { useClientRect, isOnServer } from '../../utils';
import { useQuote } from '../../context/Quote';
import { useQuoteVisibility } from '../../context/QuoteVisbility';
import TransitionReveal from '../generic/TransitionReveal';
import Modal from '../generic/Modal';
import styles from './index.module.scss';

const QuoteListLazy = React.lazy(() => import('./QuoteList'));
const SummaryLazy = React.lazy(() => import('./Summary'));
const EmptyQuotePlaceholderLazy = React.lazy(() => import('./EmptyQuotePlaceholder'));

export default function QuoteView() {
  const { quote } = useQuote();
  const { isQuoteVisible, toggleQuote } = useQuoteVisibility();
  const showContent = isQuoteVisible && quote.length > 0;
  const [isSummaryExpanded, setIsSummaryExpanded] = useState(false); // reset on quotevisibility
  const globalQuoteViewTransitionRef = useRef();

  const [measureSummaryBoxRef, summaryBoxRect] = useClientRect();
  const [measureSummaryToggleRef, summaryToggleRect] = useClientRect();
  const summaryBoxToggleHeight = summaryToggleRect.height;
  const summaryHeight = isSummaryExpanded ? -summaryBoxRect.height : -summaryBoxToggleHeight;

  useEffect(() => {
    setIsSummaryExpanded(false);
    // ? return () => toggleQuote(false);
  }, [isQuoteVisible]);

  // const quoteBoxTransitionRef = useRef();
  const quoteBoxProps = useSpring({
    config: { mass: 1, tension: 200, friction: 26 },
    from: {
      opacity: 0,
      transform: `translateY(${-100}vh)`,
    },
    opacity: showContent ? 1 : 1,
    transform: `translateY(${showContent ? 0 : -100}vh)`,
    // ref: quoteBoxTransitionRef,
  });

  // const summaryBoxTransitionRef = useRef();
  const summaryBoxProps = useSpring({
    config: { mass: 1, tension: 200, friction: 26 },
    from: {
      opacity: 0,
      transform: `translateY(${-summaryBoxRect.height}px)`,
    },
    opacity: showContent ? 1 : 0,
    transform: `translateY(${showContent ? summaryHeight : -140}px)`,
    // ref: summaryBoxTransitionRef,
  });

  // todo solve issue here or reorg anims..
  // useChain(
  //   isQuoteVisible
  //     ? [globalQuoteViewTransitionRef, quoteBoxTransitionRef, summaryBoxTransitionRef]
  //     : [summaryBoxTransitionRef, quoteBoxTransitionRef, globalQuoteViewTransitionRef],
  //   [0.2, 0.4, 0.6]
  // );

  return (
    <>
      <TransitionReveal isVisible={showContent} initialTranslate={{}} animationRef={globalQuoteViewTransitionRef}>
        <Modal closeCallback={() => toggleQuote('close')} fixed portal lockBodyScroll className={styles.quoteViewModal}>
          <div className={styles.globalQuoteView} tabIndex={0} role="button" onClick={event => event.stopPropagation()}>
            <animated.div style={quoteBoxProps} className={styles.quoteBox}>
              {!isOnServer && (
                <Suspense fallback={<div />}>
                  <QuoteListLazy />
                </Suspense>
              )}
            </animated.div>
            <animated.div style={summaryBoxProps} className={styles.summaryBox}>
              {!isOnServer && (
                <Suspense fallback={<div />}>
                  <SummaryLazy
                    measureRef={measureSummaryBoxRef}
                    measureToggleRef={measureSummaryToggleRef}
                    toggleExpanded={() => setIsSummaryExpanded(state => !state)}
                    isExpanded={isSummaryExpanded}
                  />
                </Suspense>
              )}
            </animated.div>
          </div>
        </Modal>
      </TransitionReveal>

      <TransitionReveal isVisible={!showContent && isQuoteVisible}>
        <Modal closeCallback={() => toggleQuote('close')} fixed portal lockBodyScroll className={styles.quoteViewModal}>
          <TransitionReveal
            initialTranslate={{ y: '-100vh' }}
            isVisible={!showContent && isQuoteVisible}
            className={styles.globalQuoteView}
          >
            <Suspense fallback={<div />}>
              <EmptyQuotePlaceholderLazy />
            </Suspense>
          </TransitionReveal>
        </Modal>
      </TransitionReveal>
    </>
  );
}
